import { render } from "./InfoBlock.vue?vue&type=template&id=651c61fd"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__